import _ from "lodash";
import UTIL_MESSAGE from "./message";

/* ************************
 * PRIVATE
 */

const isDefined = v => v !== undefined && v !== null;

const createEmptyTopic = (topic) => {
	return {
		topic,
		active: true,
		messages: [],
	}
}

const replaceMessage = (messages = [], message, idx) => {
	if (!isDefined(idx) || idx < 0 || idx > messages.length - 1) {
		return messages;
	}
	return [...messages.slice(0, idx), message, ...messages.slice(idx + 1)];
}

const removeMessage = (messages = [], idx) => {
	if (!isDefined(idx) || idx < 0 || idx > messages.length - 1) {
		return messages;
	}
	return [...messages.slice(0, idx), ...messages.slice(idx + 1)];
}

const initTopic = (messagesByTopic, { topic } = {}) => {
	if (messagesByTopic[topic]) {
		// topic already exists
		return messagesByTopic;
	}
	const clone = {...messagesByTopic};
	clone[topic] = createEmptyTopic(topic);
	return clone;
}



/* ************************
 * PUBLIC instantiate / destroy
 */

const openTopic = (messagesByTopic, { topic } = {}) => {
	const clone = {...messagesByTopic};
	clone[topic] = createEmptyTopic(topic);
	return clone;
}

const closeTopic = (messagesByTopic, { topic } = {}) => {
	if (!messagesByTopic[topic]) {
		// topic does not exist
		return messagesByTopic;
	}
	if (!messagesByTopic[topic].active) {
		// topic is already closed
		return messagesByTopic;
	}
	const clone = {...initTopic(messagesByTopic, { topic })};
	const meta = { ...clone[topic] };
	meta.active = false;
	clone[topic] = meta;
	return clone;
}

const resetTopic = (messagesByTopic, { topic } = {}) => {	
	return openTopic(messagesByTopic, { topic });
}

const destroyTopic = (messagesByTopic, { topic } = {}) => {
	if (!messagesByTopic[topic]) {
		// topic does not exist
		return messagesByTopic;
	}

	const clone = {...messagesByTopic};
	delete clone[topic];
	return clone;
}

/* ************************
 * PUBLIC ADD MESSAGES
 */

const pushMessage = (messagesByTopic, { topic, message } = {}) => {
	if (!message) {
		return messagesByTopic;
	}
	const clone = {...initTopic(messagesByTopic, { topic })};
	const meta = { ...clone[topic] };
	meta.messages = [...meta.messages, UTIL_MESSAGE.injectMessageUuid(message)].filter(v => v);
	clone[topic] = meta;
	return clone;
}

const pushMessages = (messagesByTopic, { topic, messages } = {}) => {
	const _messages = messages.filter(v => v);
	if (!_messages.length) {
		return messagesByTopic;
	}
	const clone = {...initTopic(messagesByTopic, { topic })};
	const meta = { ...clone[topic] };
	meta.messages = [meta.messages, messages.map(m => UTIL_MESSAGE.injectMessageUuid(m))].flat().filter(v => v);
	clone[topic] = meta;
	return clone;
}

/* ************************
 * PUBLIC UPDATE MESSAGE
 */

const updateMessage = (messagesByTopic, { topic: _topic, message } = {}) => {
	const topic = _topic || message?.topic || UTIL_MESSAGE.getTopicFromUuid(message?.uuid);
	const uuid = message?.uuid;
	const batch = message?.body?.batch;
	if (!topic) {
		// fail silently
		console.error('Unable to identify message: updateMessage()', _topic, message);
		debugger;
		return messagesByTopic;
	}

	const clone = {...initTopic(messagesByTopic, { topic })};
	const meta = { ...clone[topic] };

	// Replace Message by uuid
	const messageIdx = meta.messages.findIndex(m => uuid && m.uuid === uuid);
	if (messageIdx > -1) {
		meta.messages = replaceMessage(meta.messages, message, messageIdx);
		clone[topic] = meta;
		return clone;
	}

	// Replace Message by batch
	const matchingMessages = meta.messages.filter(m => batch && m?.body?.batch === batch);
	if (matchingMessages?.length > 0) {
		meta.messages = [...meta.messages];
		matchingMessages.forEach(m => {
			const idx = meta.messages.indexOf(m);
			if (idx === -1) {
				console.error('how did we not match on mem location??');
			}
			meta.messages = removeMessage(meta.messages, idx);
		})
		clone[topic] = meta;
		return pushMessage(clone, { topic, message });
	}


	// could not find message, lets add it
	return pushMessage(messagesByTopic, { topic, message });
}



/* ************************
 * PUBLIC DELETE MESSAGE
 */

const deleteMessage = (messagesByTopic, { topic: _topic, message } = {}) => {
	const topic = _topic || message?.topic || UTIL_MESSAGE.getTopicFromUuid(message?.uuid);
	const uuid = message?.uuid;
	if (!topic || !uuid) {
		// fail silently
		console.error('Unable to identify message: deleteMessage()', _topic, message);
		return messagesByTopic;
	}

	const clone = {...initTopic(messagesByTopic, { topic })};
	const meta = { ...clone[topic] };
	const messageIdx = meta.messages.findIndex(m => m.uuid === uuid);
	if (messageIdx === -1) {
		// could not find message to delete, no state change needed
		return messagesByTopic;
	}

	// remove message
	meta.messages = removeMessage(meta.messages, messageIdx);
	clone[topic] = meta;
	return clone;
}



const UTIL_FALCON_UPLOAD_STATE = {
	// PUBLIC instantiate / destroy
	openTopic,
	closeTopic,
	resetTopic,
	destroyTopic,

	// PUBLIC ADD MESSAGES
	pushMessage,
	pushMessages,

	// PUBLIC UPDATE MESSAGE
	updateMessage,

	// PUBLIC DELETE MESSAGE
	deleteMessage,
}

export default UTIL_FALCON_UPLOAD_STATE;